import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase"; // ඔබේ firebase.js එකෙන් db එක import කරගන්න
import "./AlbumGalleryPage.css";

const AlbumGalleryPage = () => {
  const { categoryId, albumName } = useParams();
  const navigate = useNavigate();

  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentAlbumName, setCurrentAlbumName] = useState("");

  // 🔥 lightbox states
  const [activeIndex, setActiveIndex] = useState(null);

  // Firestore එකෙන් අදාළ ඇල්බමය සහ එහි image URLs ටික Fetch කරගැනීම
  useEffect(() => {
    const fetchAlbumImages = async () => {
      setLoading(true);
      try {
        // decoded albumName එක ලබා ගැනීම (URL එකේ spaces වෙනුවට %20 එන නිසා)
        const decodedAlbumName = decodeURIComponent(albumName);

        // categorized_albums collection එකෙන් අදාළ category එක සහ albumName එකට අදාළ document එක සෙවීම
        const q = query(
          collection(db, "categorized_albums"),
          where("category", "==", categoryId)
        );

        const querySnapshot = await getDocs(q);
        let foundImages = [];
        let realName = decodedAlbumName;

        querySnapshot.forEach((doc) => {
          const data = doc.data();
          // document ID එක හෝ albumName එක match වෙනවද බැලීම
          if (doc.id === decodedAlbumName || data.albumName === decodedAlbumName) {
            foundImages = data.images || [];
            realName = data.albumName || decodedAlbumName;
          }
        });

        setImages(foundImages);
        setCurrentAlbumName(realName);
      } catch (e) {
        console.error("Error fetching album images: ", e);
        setImages([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAlbumImages();
  }, [categoryId, albumName]);

  // 🔥 keyboard controls
  useEffect(() => {
    const handleKey = (e) => {
      if (activeIndex === null) return;

      if (e.key === "Escape") setActiveIndex(null);
      if (e.key === "ArrowRight") nextImage();
      if (e.key === "ArrowLeft") prevImage();
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [activeIndex, images.length]);

  const nextImage = () => {
    setActiveIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setActiveIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  return (
    <div className="ag-container">
      {/* Header */}
      <header className="ag-header">
        <button className="ag-back-btn" onClick={() => navigate(-1)}>
          ← Back
        </button>

        <div className="ag-title-wrap">
          <h1 className="ag-title">
            {currentAlbumName ? currentAlbumName.replace(/[-_]/g, " ") : ""}
          </h1>
          <span className="ag-count">{images.length} photos</span>
        </div>
      </header>

      {/* Content */}
      {loading ? (
        <p className="ag-loading">Loading photos…</p>
      ) : images.length === 0 ? (
        <p className="ag-empty">No images found</p>
      ) : (
        <div className="ag-gallery">
          {images.map((url, i) => (
            <div
              key={i}
              className="ag-photo-card"
              onClick={() => setActiveIndex(i)}
            >
              <img src={url} alt={`photo-${i}`} />
              <div className="ag-photo-overlay" />
            </div>
          ))}
        </div>
      )}

      {/* 🔥 FULL SCREEN VIEW */}
      {activeIndex !== null && (
        <div className="ag-lightbox">
          <button className="ag-close" onClick={() => setActiveIndex(null)}>
            ✕
          </button>

          <button className="ag-nav left" onClick={prevImage}>
            ‹
          </button>

          <img
            src={images[activeIndex]}
            className="ag-lightbox-img"
            alt="full"
          />

          <button className="ag-nav right" onClick={nextImage}>
            ›
          </button>
        </div>
      )}
    </div>
  );
};

export default AlbumGalleryPage;